import { Component, OnDestroy, OnInit } from '@angular/core';
import { ChannelsService } from 'src/app/services/channels.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageManagerService } from 'src/app/services/storage-manager.service';
import { Location } from '@angular/common';
import { AppComponent } from 'src/app/app.component';
import { ChannelResponse } from '../../models';
import { LocalisationService } from 'src/app/services/localisation.service';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-shows',
	templateUrl: './shows.component.html',
	styleUrls: ['./shows.component.scss']
})
export class ShowsComponent {
}
